import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("jenova_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pt-32 pb-32 min-h-screen flex items-center">
      <div className="max-w-md w-full mx-auto px-6">
        <Link to="/" className="font-serif text-2xl font-light text-[#1A1C1A]">
          Jenova <span className="italic text-stone-500">Collective</span>
        </Link>
        <p className="mt-10 text-xs uppercase tracking-[0.3em] text-stone-500 font-semibold">Admin</p>
        <h1 className="mt-3 font-serif text-4xl md:text-5xl font-light tracking-tight text-[#1A1C1A]">
          Enter the <em className="italic text-stone-600">studio</em>.
        </h1>

        <form onSubmit={submit} className="mt-10 space-y-6">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Email</label>
            <input
              data-testid={ADMIN.emailInput}
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-stone-300 py-3 focus:border-[#1A1C1A] focus:outline-none transition-colors font-sans"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-stone-500 font-semibold">Password</label>
            <input
              data-testid={ADMIN.passwordInput}
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-stone-300 py-3 focus:border-[#1A1C1A] focus:outline-none transition-colors font-sans"
            />
          </div>
          {error && (
            <p data-testid={ADMIN.loginError} className="text-sm text-[#8B3A3A]">
              {error}
            </p>
          )}
          <button
            data-testid={ADMIN.loginButton}
            type="submit"
            disabled={loading}
            className="w-full bg-[#1A1C1A] text-[#F9F9F6] hover:bg-[#3C3E3C] px-8 py-4 rounded-full font-sans text-sm tracking-wider uppercase disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
